import React,{useState,useEffect} from 'react'
import {IoArrowUpOutline} from 'react-icons/io5'
import Styled from 'styled-components'


const Container = Styled.button`
	z-index: 1000;
	width: 54px;
	height: 54px;
	visibility: ${({show}) => show ? "visible" : "hidden"};
	opacity: ${({show}) => show ? "1" : "0"};
	display: grid;
	justify-content: center;
	align-items: center;
	border: .8px solid #FFF21F44;
	border-radius: 50%;
	cursor: pointer;
	position: fixed;
	right: ${({position}) => position.right};
	bottom: ${({position}) => position.bottom};
	color: #65678B;
	background-color: #FFF21Faa;
	font-size: 1.4rem;


	:hover{
		background-color: #65678B77;
		color: #FFF21F;
		transition: .4s ease-in background-color color;
	}


`

const BeUp = (props) =>{
	const [isVisible, setIsVisible] = useState(false);

	const handleScroll = () =>{
		if(window.pageYOffset > 320){
			setIsVisible(true)
		}else{
			setIsVisible(false)
		}
	}


	const scrollUp = () =>{
		window.scrollTo({top:0,behaviour:`smooth`})
	}

	useEffect(()=>{
		window.addEventListener('scroll' ,handleScroll);

		return () => window.removeEventListener('scroll',handleScroll);
	},[])
	return(
		<Container show={isVisible} position={props} onClick={scrollUp} >
			<IoArrowUpOutline />
			
		</Container>
		)
}

export default BeUp